import React from "react";
import "../../App.css";
import PropTypes from "prop-types";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import { Link, Redirect } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import { AppBar, Toolbar } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import axios from "axios";
import logo from "../../assets/img/cw_logo.png";

const styles = {
  menu_button: {
    marginRight: -16,
  },
  title: {
    flexGrow: 1,
    color: "black",
    marginTop: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  list: {
    width: "80%",
    height: "100%",
    marginLeft: "10%",
  },
  drawerPaper: {
    backgroundColor: "rgba(52, 52, 52, 0.9)",
    width: "45%",
    background: "inherit",
    borderRadius: "2px",
    overflow: "hidden",
    content: "",
  },
  list_title: {
    color: "white",
    "&:hover": {
      color: "#F6277F",
    },
    fontSize: "3rem",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  bottom_bar: {
    marginTop: 24,
    backgroundColor: "#FAFAFA",
    borderWidth: 1,
    borderColor: "#EAEAEA",
    borderStyle: "solid",
  },
  parent: {
    "&:hover": {
      backgroundColor: "#FFF",
    },
    paddingLeft: "10%",
  },
};

const login_options = [
  "Leaf Library",
  "Add Product",
  "About Brand",
  "Request Change",
  "Subscription",
  "LogOut",
];

class TopAppBarOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedIndex: 0,
      right: false,
    };
  }

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleListItemClick = (index) => {
    this.setState({ selectedIndex: index });
  };

  sideList(side) {
    const { classes } = this.props;
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
        role="presentation"
        onClick={this.toggleDrawer(side, false)}
        onKeyDown={this.toggleDrawer(side, false)}
      >
        <List style={{ zIndex: 1 }}>
          <ListItemIcon
            style={{ paddingBottom: "20%", paddingTop: "10%" }}
            onClick={this.toggleDrawer("right", false)}
          >
            <CloseIcon
              style={{
                fontSize: 30,
                color: "white",
                position: "absolute",
                right: 0,
                paddingRight: "5%",
              }}
            />
          </ListItemIcon>
          {login_options.map((text, index) => (
            <ListItem button key={text} className={classes.parent}>
              <Link
                to={
                  index === 0
                    ? "/company/leaflibrary"
                    : index === 1
                    ? "/company/product"
                    : index === 2
                    ? "/company/aboutbrand"
                    : index === 3
                    ? "/company/companyinfo"
                    : index === 4
                    ? "/company/subscription"
                    : index === 5
                    ? "/login"
                    : null
                }
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  fontFamily: "Open Sans",
                  textDecoration: "none",
                }}
                className={classes.list_title}
              >
                {text}
              </Link>
            </ListItem>
          ))}
        </List>
        <img
          alt=""
          style={{
            height: 60,
            padding: "10%",
            marginLeft: "35%",
            position: "absolute",
            bottom: 0,
          }}
          src={logo}
        />
      </div>
    );
  }

  toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ [side]: open });
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container style={{ marginBottom: 70 }}>
        <AppBar
          position="fixed"
          style={{
            backgroundColor: "#FAFAFA",
            boxShadow: "none",
            borderBottom: "0.1px solid #C9C9C9",
          }}
        >
          <Toolbar>
            <Grid justify="space-between" container>
              <Grid item>
                <Typography
                  variant="h5"
                  style={{
                    flexGrow: 1,
                    color: "black",
                    marginTop: 10,
                    fontWeight: "bold",
                    fontFamily: "Open Sans",
                  }}
                >
                  <Link
                    to="/"
                    style={{
                      color: "black",
                      fontFamily: "Open Sans",
                      textDecoration: "none",
                    }}
                  >
                    CanaWho
                  </Link>
                </Typography>
              </Grid>
              <Grid item>
                <img
                  alt=""
                  style={{
                    padding: 10,
                    marginLeft: -65,
                    height: 30,
                    boxSizing: "unset",
                  }}
                  src={logo}
                />
              </Grid>
              {this.props.disabled ? null : (
                <Grid item>
                  <IconButton
                    edge="start"
                    className={classes.menu_button}
                    aria-label="menu"
                    onClick={this.toggleDrawer("right", true)}
                  >
                    <MenuIcon style={{ fontSize: 30, color: "black" }} />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Toolbar>
        </AppBar>
        {this.props.disabled ? null : (
          <SwipeableDrawer
            variant="temporary"
            anchor="right"
            open={this.state.right}
            onClose={this.toggleDrawer("right", false)}
            onOpen={this.toggleDrawer("right", true)}
            classes={{ paper: classes.drawerPaper }}
          >
            {this.sideList("right")}
          </SwipeableDrawer>
        )}
      </Grid>
    );
  }
}

TopAppBarOptions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TopAppBarOptions);
